function formatShareableUrl(to: string, param: string, paramValue: string): URL {
  const urlToGo = new URL(to);
  urlToGo.searchParams.set(param, paramValue);

  return urlToGo;
}

function formatDetailsPageUrlShareLink(params?: string): URL | null {
  const detailsLink = process.env.REACT_APP_DETAILS_LINK;

  if (!detailsLink || !params) return null;

  return formatShareableUrl(detailsLink, 'id', params);
}

export const url = {
  format: {
    toShareable: formatShareableUrl,
    toShareableDetailsPage: formatDetailsPageUrlShareLink
  }
};
